var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBanknote2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9ZM10.5 12C10.5 11.1716 11.1716 10.5 12 10.5C12.8284 10.5 13.5 11.1716 13.5 12C13.5 12.8284 12.8284 13.5 12 13.5C11.1716 13.5 10.5 12.8284 10.5 12Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 8.25C1.5 6.17894 3.17894 4.5 5.25 4.5H18.75C20.8211 4.5 22.5 6.17894 22.5 8.25V15.75C22.5 17.8211 20.8211 19.5 18.75 19.5H5.25C3.17894 19.5 1.5 17.8211 1.5 15.75V8.25ZM3.02895 7.88812C3.9214 7.62503 4.62503 6.9214 4.88812 6.02895C3.93535 6.18299 3.18299 6.93535 3.02895 7.88812ZM19.1119 17.9711C20.0647 17.817 20.817 17.0647 20.9711 16.1119C20.0786 16.375 19.375 17.0786 19.1119 17.9711ZM21 14.566C19.2539 14.8769 17.8769 16.2539 17.566 18H6.43403C6.12315 16.2539 4.74605 14.8769 3 14.566V9.43403C4.74605 9.12315 6.12315 7.74605 6.43403 6H17.566C17.8769 7.74605 19.2539 9.12315 21 9.43403V14.566ZM4.88812 17.9711C4.62503 17.0786 3.9214 16.375 3.02895 16.1119C3.18299 17.0647 3.93534 17.817 4.88812 17.9711ZM19.1119 6.02895C20.0647 6.18299 20.817 6.93534 20.9711 7.88812C20.0786 7.62503 19.375 6.9214 19.1119 6.02895Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanknote2);
export default __webpack_public_path__ + "static/media/banknote-2.b39078216cff17c473a1f6d707f3d8d5.svg";
export { ForwardRef as ReactComponent };